/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { logger as log } from '@common/logger';
import { injectable } from 'inversify';
import { getAgent, SwitchRoleAgent } from './agent';

const is = require('is_js');

const SERVICE_NAME = 'SwitchRoleService';

@injectable()
export class SwitchRolesPageService {
  private static instance: SwitchRolesPageService;
  public agent: SwitchRoleAgent;
  static displayName = 'SwitchRolesPageService';
  constructor(props: any = {}) {
    this.agent = getAgent();
  }

  // public async getPageContent() {
  //   let content: any = {};
  //   let compProps: any = null;
  //   const agent = getAgent();

  //   //Header Props
  //   compProps = await agent.getHeaderProps({});
  //   if (compProps) {
  //     content = { ...content, ...compProps };
  //   }

  //   // //Main Props
  //   // compProps = await agent.getMainSectionProps({});
  //   // if (compProps) {
  //   //   content = { ...content, ...compProps };
  //   // }

  //   //Feature Section Props
  //   compProps = await agent.getFeatureSectionProps({});
  //   if (compProps) {
  //     content = { ...content, ...compProps };
  //   }

  //   //Footer Props
  //   compProps = await agent.getFooterProps({});
  //   if (compProps) {
  //     content = { ...content, ...compProps };
  //   }

  //   return content;
  // }
  // public async updateProfile(args: any) {
  //   console.log("Profile data in service", args);
  //   const agent = getAgent();
  //   return agent?.getUpdateProfile(args);
  // }
}
